import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link,useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { SIGNUP_ACTIONS } from "../../store/reducers/signup-actions";
import authService from "../../services/auth.service";




const SudentRegister = () => {

  const dispatch = useDispatch();
  const studentData = useSelector((state) => state.signup);

  const signupState = useSelector(state => state.signup);

  const [showIncompleteMsg, setShowIncompleteMsg] = useState(false);

    const isFormComplete =
    signupState.fullName &&
    signupState.email &&
    signupState.phone &&
    signupState.password &&
    signupState.confirmPassword;


    // const isVerified =
    // signupState.emailStatus.isVerified &&
    // signupState.phoneStatus.isVerified;

      const isVerified =
    signupState.emailStatus.isVerified 


    const isDisabled = !(isFormComplete && isVerified);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "studentName") 
      dispatch({ type: SIGNUP_ACTIONS.SET_NAME, payload: value });
    if (name === "emailId") 
      if(studentData.emailStatus.isReadonly==true){
        alert("OTP Already sent you cannot change Email");
        return
      }else{
        dispatch({ type: SIGNUP_ACTIONS.SET_EMAIL, payload: value });
      }
    if (name === "email_otp") 
      dispatch({ type: SIGNUP_ACTIONS.EMAIL_OTP_SET, payload: value }); 
    if (name === "phone_otp") 
      dispatch({ type: SIGNUP_ACTIONS.PHONE_OTP_SET, payload: value });   
      
    if (name === "phoneNumber") 
      dispatch({ type: SIGNUP_ACTIONS.SET_PHONE, payload: value });
    if (name === "password") 
      dispatch({ type: SIGNUP_ACTIONS.SET_PASSWORD, payload: value });
    if (name === "confirmPassword") 
      dispatch({ type: SIGNUP_ACTIONS.SET_CONFIRM_PASSWORD, payload: value });

  };
   const resetVerification = (type_of) =>{
    if(type_of=="email_otp"){
      dispatch({ type: SIGNUP_ACTIONS.EMAIL_VERIFICATION_RESET, payload: "value" });
    }else{
      dispatch({ type: SIGNUP_ACTIONS.PHONE_VERIFICATION_RESET, payload: "false" });
    }
    return;
   }
  const OtpGenerate = async(type_of) => {
   
    //make service request to generate email otp
    const otpSentStatus = await authService.generateOTP(type_of,type_of=="email_otp"?studentData.email:studentData.phone);
    if(otpSentStatus.success===true){
        Swal.fire({
        title: otpSentStatus.message,
        icon: "success",
        timer: 1000,
        showConfirmButton: false,
      });
      dispatch({type:type_of=="email_otp"? SIGNUP_ACTIONS.EMAIL_OTP_SENT  : SIGNUP_ACTIONS.PHONE_OTP_SENT,payload:{referenceId:otpSentStatus.refrence_id,isReadonly:true}})
    }else{
       Swal.fire({
        title: otpSentStatus.message,
        icon: "warning",
        timer: 1000,
        showConfirmButton: false,
      });
    }
  };

  const OtpValidate =  async (type_of) => {
     
    if(type_of=="email_otp" && studentData.emailStatus.otp==null){
      return ;
    }
    if(type_of=="phone_otp" && studentData.phoneStatus.otp==null){
      return ;
    }
    //make service request to validate email otp
    const otpSentStatus = await authService.validateOTP(type_of,studentData);
    if(otpSentStatus.success===true){
        Swal.fire({
        title: otpSentStatus.message,
        icon: "success",
         timer: 1000,
        showConfirmButton: false,
      });
      dispatch({type:type_of=="email_otp"? SIGNUP_ACTIONS.EMAIL_VERIFIED :SIGNUP_ACTIONS.PHONE_VERIFIED ,payload:{referenceId:otpSentStatus.refrence_id,isReadonly:true}})
    }else{
       Swal.fire({
        title: otpSentStatus.message,
        icon: "warning",
         timer: 1000,
        showConfirmButton: false,
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };



  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {

    if (isDisabled) {
     
      setShowIncompleteMsg(true);
      setTimeout(() => setShowIncompleteMsg(false), 2000); // Hide after 2s
      return;
    }
    
    
   

    setLoading(true);

    const signupResponse =  await authService.registerUser(studentData);
    if(signupResponse.success==true){
      //Swal with success
      Swal.fire({
        title: `${signupResponse.message}`,
        icon: "success",
        timer: 1000,
        showConfirmButton: true,
      });
      setLoading(false);

      navigate("/student/login",{replace:true})
      dispatch({ type: SIGNUP_ACTIONS.RESET });
      
      //reset the form here
      //navigate to login 
    }else{
      //swal with with Message
      Swal.fire({
        title: `${signupResponse.message}`,
        icon: "error",
        showConfirmButton: true,
      });
       setLoading(false);
    }

    return;
  };

  return (
    <>
      <div className="Student-login-box">
        <div className="student-login-page-2">
          <h2 className="login-header">Student Register</h2>
          {/* <p>{JSON.stringify(studentData)}</p> */}
          <div className="login-form-1">
            <div className="form-group-login-page">
              <label htmlFor="email">Enter Your Name</label>
              <input
                onChange={handleInputChange}
                value={studentData.name}
                name="studentName"
                type="text"
                id="studentName"
                required
                placeholder="Your Name"
              />
            </div>
            <div className="form-group-1">
              <label htmlFor="aadhaar" className="form-label">
                Enter Your Email Id
              </label>
              <div className="input-box">
                <input
                  onChange={handleInputChange}
                  value={studentData.emailId}
                  name="emailId"
                  type="email"
                  id="emailId"
                  readOnly={studentData.emailStatus.isReadonly}
                  className="form-input"
                  style={
                          studentData.emailStatus.isVerified
                            ? { border: "1px solid green" }
                            : {}
                        }
                  placeholder="Email ID"
                  required
                />
                 
                {studentData.emailStatus.isVerified==false && 
                <>
                <input
                  type="text"
                  id="emailIdOtp"
                  name="email_otp"
                  onChange={handleInputChange}
                  className="otp-input"
                  placeholder="Enter Otp"
                  required
                />
                
                <button
                  className="getOtp-btn"
                  onClick={() => studentData.emailStatus.isOtpSent==true? OtpValidate("email_otp"):OtpGenerate("email_otp")}
                >
                 {studentData.emailStatus.isOtpSent==true?"Verify":"Get Otp"} 
                </button>
                </> 
                }
              </div>
              {studentData.emailStatus.isVerified && (
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
                  <span style={{ color: "green", fontWeight: "bold" }}>Verified Email</span>
                  <button 
                    onClick={() => resetVerification("email_otp")} 
                    style={{ background: "transparent", border: "none",fontWeight:"normal", color: "gray", cursor: "pointer" }}
                  >
                    Reset Verification
                  </button>
                </div>
              )}

            </div>
            <div className="form-group-1">
              <label htmlFor="phoneNumber" className="form-label">
                Enter Mobile Number (without +91)
              </label>
              <div className="input-box">
                <input
                  onChange={handleInputChange}
                  value={studentData.phone}
                  name="phoneNumber"
                  type="number"
                  id="phoneNumber"
                  // readOnly={studentData.phoneStatus.isReadonly}
                  className="form-input"
                  // style={
                  //         studentData.phoneStatus.isVerified
                  //           ? { border: "1px solid green" }
                  //           : {}
                  //       }
                  placeholder="Mobile Number"
                  required
                />
                 
                {/* {studentData.phoneStatus.isVerified==false && 
                <>
                <input
                  type="text"
                  id="emailIdOtp"
                  name="phone_otp"
                  onChange={handleInputChange}
                  className="otp-input"
                  placeholder="Enter Otp"
                  required
                />
                
                <button
                  className="getOtp-btn"
                  onClick={() => studentData.phoneStatus.isOtpSent==true? OtpValidate("phone_otp"):OtpGenerate("phone_otp")}
                >
                 {studentData.phoneStatus.isOtpSent==true?"Verify":"Get Otp"} 
                </button>
                </> 
                } */}
              </div>
      
              {/* {studentData.phoneStatus.isVerified && (
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
                  <span style={{ color: "green", fontWeight: "bold" }}>Verified Email</span>
                  <button 
                    onClick={() => resetVerification("phone_otp")} 
                    style={{ background: "transparent", border: "none",fontWeight:"normal", color: "gray", cursor: "pointer" }}
                  >
                    Reset Verification
                  </button>
                </div>
              )} */}

            </div>
            <div className="form-group-login-page">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <input
                  onChange={handleInputChange}
                  value={studentData.password}
                  name="password"
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="***********"
                />
             
              </div>
            </div>
            <div className="form-group-login-page">
              <label htmlFor="password">Confirm Password</label>
              <div className="input-wrapper">
                <input 
                  value={studentData.connfirmPassword}  
                  onChange={handleInputChange}
                  name="confirmPassword"
                  id="confirmPassword"
                  type={showPassword ? "text" : "password"}
                  placeholder="***********"
                />
                <div
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  className="icon"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {showPassword ? (
                      <>
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                        <line x1="1" y1="1" x2="23" y2="23" />
                      </>
                    ) : (
                      <>
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                        <circle cx="12" cy="12" r="3" />
                      </>
                    )}
                  </svg>
                </div>
              </div>
            </div>

            <div className="form-actions">
               <p>
                {isDisabled && "Complete your form!"}
              </p>
              <button
                type="button"
                disabled={isDisabled}
                onClick={handleSubmit}
                className="login-btn"
                style={{
                  backgroundColor: isDisabled ? '#ccc' : '#14b8a6',
                  color: '#fff',
                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? <div className="loader"></div> : "Register"}
              </button>
             
              {/* {showIncompleteMsg && (
                <div style={{ color: 'red', marginTop: '10px' }}>
                  Complete your form!
                </div>
              )} */}
               
              <div className="register-link">
                <p>Already have an account?</p>
                <Link to="/student/login">Login</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SudentRegister;
